import React, { useState } from "react";
import AsyncSelect from "react-select/async";
import { employeeSelectOptionRequest } from "../../api/employee";
import { debounce } from "lodash";
import { useRef } from "react";

export function EmployeeAsyncSelect({
    placeholder = "Start typing to see options...",
    onChange,
    labelKey = "label",
    disabled = false,
    isMulti = false
}) {
    const [employee, setEmployee] = useState(null);

    const handleEmployeeChange = (employee) => {
        setEmployee(employee);
        if(onChange) {
            onChange(employee);
        }
    };

    const debounceMethod = useRef(null);

    const loadEmployees = (term, callback) => {
        if (debounceMethod && debounceMethod.current) {
            debounceMethod.current.cancel();
        }
        debounceMethod.current = debounce(
            () =>
                employeeSelectOptionRequest({ term }, (result) =>
                    callback(result),
                ),
            300,
        );
        debounceMethod.current();
    };

    return (
        <AsyncSelect
            value={employee}
            cacheOptions
            loadOptions={loadEmployees}
            className="basic-multi-select"
            classNamePrefix="select"
            getOptionLabel={(e) => e[labelKey]}
            onChange={handleEmployeeChange}
            placeholder={placeholder}
            isDisabled={disabled}
            isMulti={isMulti}
        />
    );
}
